import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class RelationshipService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'Relationship/';
  // fetch all Relationship in the database
  allRelationshipData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getRelationship(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getRelationshipByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postRelationship(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteRelationship(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateRelationship(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
